module.exports = __webpack_public_path__ + "img/sumdes_1920.58526bb9.png";